import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import productData from "../Datas/productData";
import { formatMoney } from "../config/store";

const carouselData = [
  {
    type: "split",
    subTitle: "EVERYDAY, CONSIDERED",
    title: "Small Details, Better Days",
    desc: "Useful paper, home and personal pieces chosen for colour, texture and purpose.",
    btnText: "SHOP NOW",
    images: ["/main/m1-4.jpg"],
    bgColor: "#527373"
  },
  {
    type: "vertical-three",
    title: "Texture in Focus",
    desc: "Tactile materials and grounded colour for the things you reach for often.",
    btnText: "SHOP NOW",
    images: ["/main/m1-3.jpg"]
  },
  {
    type: "full",
    title: "New Arrivals",
    desc: "Freshly added goods for desks, homes, wardrobes and quiet routines.",
    btnText: "SHOP NOW",
    images: ["/main/m1-2.jpg"]
  },
  {
    type: "full",
    title: "Notes Worth Sending",
    desc: "Original card and writing sets for thanks, celebrations and just-because messages.",
    btnText: "SHOP PAPER GOODS",
    images: ["/main/m1-1.jpg"]
  }
];

function Main() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 6000);
    return () => clearInterval(timer);
  }, [currentSlide]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselData.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselData.length) % carouselData.length);
  };

  const renderSlideContent = (slide) => {
    switch (slide.type) {
      case "split":
        return (
          <div className="slide-content split-layout">
            <div className="text-section" style={{ backgroundColor: slide.bgColor }}>
              <div className="text-container">
                <span className="subtitle">{slide.subTitle}</span>
                <h1 className="title">{slide.title}</h1>
                <p className="desc">{slide.desc}</p>
                <Link to="/shop" className="shop-btn">{slide.btnText}</Link>
              </div>
            </div>
            <div className="image-section">
              <img src={slide.images[0]} alt={slide.title} />
            </div>
          </div>
        );
      case "vertical-three":
        return (
          <div className="slide-content vertical-three-layout">
            <div className="images-container">
              {slide.images.map((img, idx) => (
                <div key={idx} className="image-item">
                  <img src={img} alt={`${slide.title} ${idx}`} />
                </div>
              ))}
            </div>
            <div className="overlay-text centered">
              <h1 className="title">{slide.title}</h1>
              <p className="desc">{slide.desc}</p>
              <Link to="/shop" className="shop-btn">{slide.btnText}</Link>
            </div>
          </div>
        );
      case "grid-mix":
        return (
          <div className="slide-content grid-mix-layout">
            <div className="grid-container">
              <div className="grid-left">
                <img src={slide.images[0]} alt={slide.title} />
              </div>
              <div className="grid-right">
                <div className="grid-right-top">
                  <div className="grid-right-top-left">
                    <img src={slide.images[1]} alt={slide.title} />
                  </div>
                  <div className="grid-right-top-right">
                    <img src={slide.images[2]} alt={slide.title} />
                  </div>
                </div>
                <div className="grid-right-bottom">
                  <img src={slide.images[3]} alt={slide.title} />
                </div>
              </div>
            </div>
            <div className="overlay-text">
              <h1 className="title">{slide.title}</h1>
              <p className="desc">{slide.desc}</p>
              <Link to="/shop" className="shop-btn">{slide.btnText}</Link>
            </div>
          </div>
        );
      case "full":
        return (
          <div className="slide-content full-layout">
            <img src={slide.images[0]} alt={slide.title} />
            <div className="overlay-text">
              <h1 className="title">{slide.title}</h1>
              <p className="desc">{slide.desc}</p>
              <Link to="/shop" className="shop-btn">{slide.btnText}</Link>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="main">
      <section className="hero-carousel">
        <div className="carousel-inner">
          {carouselData.map((slide, index) => (
            <div
              key={index}
              className={`carousel-item ${index === currentSlide ? "active" : ""}`}
            >
              {renderSlideContent(slide)}
            </div>
          ))}
        </div>

        <div className="carousel-controls">
          <button onClick={prevSlide} className="control-btn prev">
            <FiArrowLeft />
          </button>
          <button onClick={nextSlide} className="control-btn next">
            <FiArrowRight />
          </button>
        </div>
      </section>

      {/* Category browse section */}
      <section className="browse-section">
        <h2 className="section-title">Find Your Kind of Useful</h2>
        <div className="browse-grid">
          <div className="browse-item">
            <img src="/main/m2-1.jpg" alt="Home Goods" />
            <span className="item-label">HOME GOODS</span>
          </div>
          <div className="browse-item">
            <img src="/main/m2-2.jpg" alt="Greeting Cards" />
            <span className="item-label">PAPER GOODS</span>
          </div>
          <div className="browse-item">
            <img src="/main/m2-3.jpg" alt="Accessories" />
            <span className="item-label">ACCESSORIES</span>
          </div>
        </div>
      </section>

      {/* Promo Section */}
      <section className="promo-section" style={{ backgroundImage: "url('/main/m3.jpg')" }}>
        <div className="promo-content">
          <span className="promo-subtitle">A SMALL, DELIBERATE COLLECTION</span>
          <h2 className="promo-title">Thoughtful Objects For Daily Rituals</h2>
          <Link to="/about" className="info-btn">OUR APPROACH</Link>
        </div>
      </section>

      {/* Everyday moments section */}
      <section className="split-info-section everyday-moments">
        <div className="info-image">
          <img src="/main/m4.jpg" alt="A colourful arrangement of practical gift items" />
        </div>
        <div className="info-text pink-bg">
          <h2 className="info-title">Made For The Moments Between</h2>
          <p className="info-desc">Small objects that help a desk, bag or shelf feel more personal.</p>
          <Link to="/shop" className="shop-btn">SHOP NOW</Link>
        </div>
      </section>

      {/* Stationery Section (Split Inverse) */}
      <section className="split-info-section stationery-nerds inverse">
        <div className="info-text teal-bg">
          <h2 className="info-title">For People Who Still Write Things Down</h2>
          <p className="info-desc">Cards, notes and paper goods with room for your own words.</p>
          <Link to="/shop" className="shop-btn">SHOP NOW</Link>
        </div>
        <div className="info-image">
          <img src="/main/m5.jpg" alt="Stationery" />
        </div>
      </section>

      {/* New Arrivals Section */}
      <section className="new-arrivals-section">
        <h2 className="section-title left">New Arrivals</h2>
        <div className="product-grid">
          {productData.slice(0, 4).map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <span className="product-price">{formatMoney(product.price)}</span>
              </div>
            </div>
          ))}
        </div>
        
      </section>

      {/* Budget Section */}
      <section className="budget-section">
        <h2 className="section-title">Good Finds At Every Price</h2>
        <div className="budget-grid">
          <div className="budget-item">
            <img src="/main/m6-1.jpg" alt="Small paper and desk goods" />
            <span className="item-label">Under HK$100</span>
          </div>
          <div className="budget-item">
            <img src="/main/m6-2.jpg" alt="Body care and textile accessories" />
            <span className="item-label">Under HK$150</span>
          </div>
          <div className="budget-item">
            <img src="/main/m6-3.jpg" alt="Jewellery and art gifts" />
            <span className="item-label">Under HK$180</span>
          </div>
        </div>
      </section>

      {/* Fun For All Ages Section */}
      <section className="split-info-section fun-ages inverse">
        <div className="info-text purple-bg">
          <h2 className="info-title">Make Time To Play</h2>
          <p className="info-desc">Puzzles, activity books and supervised creative play for slower afternoons.</p>
          <Link to="/shop" className="shop-btn">SHOP FUN + GAMES</Link>
        </div>
        <div className="info-image">
          <img src="/main/m7.jpg" alt="Puzzles, an activity book and modelling dough" />
        </div>
      </section>

      {/* Care guidance promo section */}
      <section className="promo-section care-promo" style={{ backgroundImage: "url('/main/m8.jpg')" }}>
        <div className="promo-content">
          <span className="promo-subtitle">USE WELL, KEEP LONGER</span>
          <h2 className="promo-title">Care Makes Everyday Things Last</h2>
          <Link to="/faq" className="info-btn">READ CARE NOTES</Link>
        </div>
      </section>

      {/* Material notes section */}
      <section className="journal-section">
        <div className="journal-header">
          <h2 className="section-title left">Material Notes</h2> 
        </div>
        <div className="journal-grid">
          <div className="journal-item">
            <div className="journal-image">
              <img src="/main/m9-1.jpg" alt="Close view of textured paper goods" />
            </div>
            <div className="journal-info">
              <h3 className="journal-title">Paper Likes Clean, Dry Hands</h3>
              <p className="journal-desc">
                Keep cards and prints away from humidity and direct sun. Let fresh ink dry
                before folding, stacking or returning sheets to their box.
              </p>
            </div>
          </div>
          <div className="journal-item">
            <div className="journal-image">
              <img src="/main/m9-2.jpg" alt="Glazed ceramic mug in soft light" />
            </div>
            <div className="journal-info">
              <h3 className="journal-title">Check Ceramic Before Every Pour</h3>
              <p className="journal-desc">
                Hand washing protects printed surfaces. Retire a mug if a chip or crack
                appears, and remember that hot drinks and ceramic surfaces can burn.
              </p>
            </div>
          </div>
          <div className="journal-item">
            <div className="journal-image">
              <img src="/main/m9-3.jpg" alt="Cotton canvas and velvet textile details" />
            </div>
            <div className="journal-info">
              <h3 className="journal-title">Textiles Prefer A Gentle Touch</h3>
              <p className="journal-desc">
                Spot clean bags in cool water, air dry naturally and protect printed or
                velvet surfaces from heat. Dark colour can transfer while damp.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Main;
